import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GridComponent, ExcelExportEvent } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { IPeerReviewDedOutputModel, IResponseInputModel, IResponseListOutputModel, IImpactInputModel } from 'src/app/ViewModel/PeerReviewModel';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DatePipe } from "@angular/common";
import { AddImpactDialogComponent } from './add-impact-dialog/add-impact-dialog.component';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';


@Component({
  selector: 'app-add-response',
  templateUrl: './add-response.component.html',
  styleUrls: ['./add-response.component.css']
})
export class AddResponseComponent implements OnInit {
  @Input() Data: any;
  @Output() exitFunc: EventEmitter<any> = new EventEmitter();
  public responseList: IResponseListOutputModel[] = [];
  public reasonDropdown: IPeerReviewDedOutputModel[] = [];
  public impactstatus: IPeerReviewDedOutputModel[] = [];
  public impactopenclose: any[] = ['Open', 'Closed'];
  public editedRowIndex: any;
  public editedProduct: any;
  public formGroup!: FormGroup;
  public DocDate?: any
  public isAgree!: string | null;
  public disc: string = '';
  public count: number = 1;
  public min: Date = new Date();
  public toggle: boolean = false;
  selectionAction: any[] = [];
  public memberId !: number;
  public responsedate: string = '';
  public project_Id !: number;
  public groupId !: number;
  public Feature: any[] = [];
  public Roles: any[] = [];
  public submitflag: boolean = false;
  public enableFilter: boolean = false;
  public saveflag: boolean = false;
  public selectedimpactBind: Array<any> = [];
  public impYesNo: string = null;
  public impsta_DED_ID: number = null;
  public impDateClose: string = null;

  public impactType: IPeerReviewDedOutputModel[] = [];
  valueArray: any[] = [];
  impactArray: any[] = [];

  @ViewChild(GridComponent)
  private grid!: GridComponent;

  constructor(private dialog: MatDialog, private responseListService: PeerReviewService, public notificationService: NotificationService,
    private mapRoleFeatureService: MapRoleFeatureService, private commonService: CommonService, private _fileService: FileService) { }

  ngOnInit() {
    this.memberId = this.commonService.getLoggedInUserId();
    this.project_Id = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.getResponse();
    this.getImpactTypes();
    this.responseListService.getPeerStatus({ strDocNumber: this.Data.requestNo, intUID: this.memberId }).subscribe(res => {
      let comments = res.filter(x => x.remarks == "Final Comments Submitted");
      let date: Date = new Date(comments[0].action_On);
      date.setDate(date.getDate() + 7);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.responsedate = datePipe.transform(date, 'dd-MMM-yyyy');
    });
    this.enableMemberRoleFeatures();
    this.allData = this.allData.bind(this);
  }

  getImpactTypes() {
    let obj = {
      'review_No': this.Data.requestNo,
      'project_Id': this.project_Id,
      'group_Id': this.groupId,
      'member_Id': this.memberId
    }

    this.responseListService.getPeerImpactsTypes(obj).subscribe(res => {
      this.impactType = res;
    });
  }

  onValueChange(val: any, dataItem: any) {
    for (let i = 0; i < this.selectionAction.length; i++) {
      if (this.selectionAction[i].comment_Id == dataItem.comment_Id) {
        this.selectionAction[i].evidence_Remarks = val.target.value;
      }
    }
  }

  enableMemberRoleFeatures() {
    this.commonService.getProjectMemberRoles(this.project_Id, this.groupId, this.memberId).subscribe((res: any[]) => {
      this.Roles = res;
      this.submitflag = this.Roles.some(x => x.role_Short_Desc.toUpperCase().trim() == 'ECD'.toLocaleUpperCase().trim() || x.role_Short_Desc.toUpperCase().trim() == 'MECD'.toLocaleUpperCase().trim());
    });
    this.commonService.getProjectMemberFeatures(this.project_Id, this.memberId, this.groupId).subscribe((res: any[]) => {
      this.Feature = res;
      this.saveflag = this.Feature.some(x => x.feature_Desc == "PR Response And Impacts" && x.feature_Id == 600007);
    });
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  getResponse() {
    let obj = {
      'review_No': this.Data.requestNo
    }
    this.responseListService.getReviewResponse(obj).subscribe((data: IResponseListOutputModel[]) => {
      this.responseList = data;
      if (this.responseList && this.responseList.length > 0) {
        this.disc = this.responseList[0].disc_No;
        for (let i = 0; i < this.responseList.length; i++) {

          if (this.disc == this.responseList[i].disc_No) {
            this.responseList[i].disc_No += this.count;
            this.count++;
          }
          else {
            this.count = 1;
            this.disc = this.responseList[i].disc_No
            this.responseList[i].disc_No += this.count;
            this.count++;
          }

        }
      }
    });
    this.responseListService.getReasonData().subscribe(data => {
      this.reasonDropdown = data;
    });
    this.responseListService.getimpactStatus().subscribe(data => {
      this.impactstatus = data;
    });

    this.isAgree = null;
  }

  public editRowIndex !: number;
  public editHandler({ sender, rowIndex, dataItem }: any) {

    this.isAgree = dataItem.responder_Agreed;
    this.editRowIndex = rowIndex;
    this.formGroup = new FormGroup({
      'remarks': new FormControl(dataItem.action_Remarks),
      'from': new FormControl(dataItem.action_By),
      'reason_dropdown': new FormControl(dataItem.dA_DED_Id),
      'reason_text': new FormControl(dataItem.reason_Remarks),
      'cid': new FormControl(dataItem.comment_Id),
      'impactOpenClose': new FormControl(dataItem.impactOpenClose),
      'impactStatus_DED_ID': new FormControl(dataItem.impactStatus_DED_ID),
      'action_Date': new FormControl(this.getFormattedDate(new Date(dataItem.action_Date))),
      'impactDateClosure': new FormControl(this.getFormattedDate(new Date(dataItem.impactDateClosure))),
      'impact': new FormControl(dataItem.impact),
    });
    if (this.isAgree == 'Y') {
      this.impYesNo = this.formGroup.get('impactOpenClose').value;
      this.impsta_DED_ID = this.formGroup.get('impactStatus_DED_ID').value;
      this.responseList[rowIndex].action_Date = new Date(dataItem.action_Date);
      this.responseList[rowIndex].impactDateClosure = new Date(dataItem.impactDateClosure);
      this.selectedimpactBind = dataItem.deD_Id != null ? dataItem.deD_Id.split(",").map(x => Number(x)) : [];
    }
    //this.responseList[rowIndex].action_Date = new Date();
    //this.DocDate = this.getFormattedDate(new Date());
    if (this.isAgree == null) {
      this.closeEditor(sender);
    }
    this.editedRowIndex = rowIndex;
    this.editedProduct = Object.assign({}, dataItem);
    sender.editRow(rowIndex);
  }

  public cancelHandler({ sender, rowIndex }: any) {
    this.closeEditor(sender, rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
    this.isAgree = null;
    this.DocDate = undefined;
    this.impYesNo = null;
    this.impsta_DED_ID = null;
    this.impDateClose = null;
    this.selectedImpact = [];
  }

  public saveHandler({ sender, rowIndex, dataItem, isNew }: any) {

    let rawData: any[] = [];
    rawData.push(dataItem);

    dataItem = this.formGroup.value;
    let obj!: IResponseInputModel;
    if (!this.isAgree) {
      this.notificationService.showToast("Please Select a Response", "Warning");
      return;
    }
    if (this.isAgree == 'Y') {
      if (!dataItem.remarks) {
        this.notificationService.showToast("Please enter Action Remarks", "Warning");
        return;
      }
      if (!dataItem.from) {
        this.notificationService.showToast("Please enter Action By", "Warning");
        return;
      }
      if (!this.responseList[rowIndex].action_Date) {
        this.notificationService.showToast("Please enter Action On", "Warning");
        return;
      }
      // if (!this.impYesNo) {
      //   this.notificationService.showToast("Please select Status", "Warning");
      //   return;
      // }
      // if (!this.impsta_DED_ID) {
      //   this.notificationService.showToast("Please select Open/Closed With", "Warning");
      //   return;
      // }
      // if (!this.responseList[rowIndex].impactDateClosure) {
      //   this.notificationService.showToast("Please enter Date Closure", "Warning");
      //   return;
      // }
      // if (this.selectedImpact.length == 0 && this.impYesNo == 'Closed') {
      //   this.notificationService.showToast("Please select Impacts", "Warning");
      //   return;
      // }
    }
    else {
      // if (!dataItem.reason_dropdown) {
      //   this.notificationService.showToast("Please Select a Reason", "Warning");
      //   return;
      // }
      if (!dataItem.reason_text) {
        this.notificationService.showToast("Please Enter a Reason", "Warning");
        return;
      }
    }
    if (!!dataItem) {
      if (this.isAgree == 'Y') {
        obj = {
          Review_No: this.Data.requestNo,
          Comment_Id: dataItem.cid,
          Save_Type: "PARTIAL",
          IsAgreed: this.isAgree,
          Response_Remarks: dataItem.remarks,
          Response_By: dataItem.from,
          Response_On: this.getFormattedDate(this.responseList[rowIndex].action_Date),
          ImpactOpenClose: this.impYesNo,
          ImpactStatus_DE_ID: 513,
          ImpactStatus_DED_ID: this.impsta_DED_ID,
          ImpactDateClosure: this.getFormattedDate(this.responseList[rowIndex].impactDateClosure),
          Reason_DE_Id: null,
          Reason_DED_Id: null,
          Reason_Remarks: null,
          UID: this.memberId
        }
        if (obj) {
          this.responseListService.postReviewResponse(obj).subscribe(data => {
            if (data.strErrorMsg == null) {
              let payload: IImpactInputModel = {
                strDocNumber: this.Data.requestNo,
                Save_Type: "PARTIAL",
                impactValues: JSON.stringify(this.impVal),
                commentRows: JSON.stringify(rawData),
                impactDetails: JSON.stringify(this.selectedImpact),
                UID: this.memberId
              }
              if (payload) {
                this.responseListService.postReviewImpacts(payload).subscribe(data => {
                  if (data.strErrorMsg == null) {
                    this.notificationService.showToast("Peer review Response and Impacts updated successfully.", "Success");
                    this.getResponse();
                    this.selectedImpact = [];

                  }
                  else {
                    this.notificationService.showToast(data.strErrorMsg, "Warning");
                  }
                });
              }
            }
            else {
              this.notificationService.showToast(data.strErrorMsg, "Warning");
            }
          });
        }
      }
      if (this.isAgree == 'N') {
        //let selectedReason = this.reasonDropdown.filter(data => data.deD_Id == dataItem.reason_dropdown)[0];
        obj = {
          Review_No: this.Data.requestNo,
          Comment_Id: dataItem.cid,
          Save_Type: "PARTIAL",
          IsAgreed: this.isAgree,
          Response_Remarks: null,
          Response_By: null,
          Response_On: null,
          ImpactOpenClose: null,
          ImpactStatus_DE_ID: null,
          ImpactStatus_DED_ID: null,
          ImpactDateClosure: null,
          Reason_DE_Id: null,
          Reason_DED_Id: null,
          Reason_Remarks: dataItem.reason_text,
          UID: this.memberId
        }
        if (obj) {
          this.responseListService.postReviewResponse(obj).subscribe(data => {
            if (data.strErrorMsg == null) {
              this.notificationService.showToast("Peer review Response updated successfully.", "Success");
              this.getResponse();
              this.selectedImpact = [];
            }
            else {
              this.notificationService.showToast(data.strErrorMsg, "Warning");
            }
          });
        }
      }
    }
    sender.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
    this.isAgree = null;
    this.DocDate = undefined;
    this.impYesNo = null;
    this.impsta_DED_ID = null;
    this.impDateClose = null;
  }


  selectedImpact: any[] = [];
  impVal: any[] = [];
  checkImpact: boolean = false;

  checkedImpact(event: any) {
    this.impVal = [];
    if (event && event.emittingList.length > 0) {
      this.selectedImpact = this.selectedImpact.map(x => { x.is_checked = false; return x });
      for (let obj of event.emittingList) {

        let _data = this.selectedImpact.filter(x => { x.dED_Id == parseInt(obj.value) });
        let is_checked: boolean = this.selectedImpact.some(y => y.dED_ID == obj.additionalValues.deD_Id);
        if (!is_checked) {
          this.selectedImpact.push({ dE_Id: obj.additionalValues.dE_Id, deD_Id: obj.additionalValues.deD_Id, deD_Description: obj.additionalValues.deD_Description, is_checked: true });
        }
        else {
          this.selectedImpact.filter(x => x.dED_ID == parseInt(obj.additionalValues.deD_Id))[0].is_checked = true;
        }

      }
      this.selectedImpact = this.selectedImpact.filter(c => c.is_checked == true);
      this.checkImpact = true;
    }
    else {
      this.selectedImpact = [];
      this.checkImpact = false;
    }

    this.selectedImpact.forEach(x => {
      this.impVal.push({ DedId: x.deD_Id, val: null });
    });
  }


  private closeEditor(grid: any, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
    this.isAgree = null;
    this.DocDate = undefined;
  }

  public getFormattedDate(date: any) {
    if (date != null) {
      let res = (moment(date)).format('DD-MMM-yyyy');
      return res;
    }
    else return undefined;
  }

  getValue(selectedText: any, rowIndex: any) {
    this.responseList[rowIndex].action_Date = new Date(selectedText.value);
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }

  public viewAttachmentClick(dataItem: any) {
    this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: {
        projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRC', libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId, isDeleteEnable: false
      },
    });
  }

  onChange() {
    this.toggle = !this.toggle;
  }



  onChangeImpactyesno(event) {
    this.impYesNo = event.value;
  }

  onChangeImpactstatewith(event) {
    this.impsta_DED_ID = event.value;
  }

  getImpactDateValue(selectedText: any, rowIndex: any) {
    this.responseList[rowIndex].impactDateClosure = new Date(selectedText.value);
  }

  finalSubmit() {
    if (!this.responseList.some(x => x.responder_Agreed == null)) {
      //if (!this.responseList.some(x => x.responder_Agreed == "Y" && (x.impactOpenClose == 'Open'))){
        if (!this.responseList.some(x => x.responder_Agreed == "Y" && (x.impact == null || x.isAttachment == "N"
          //|| x.impactOpenClose == null || x.impactStatus == null || x.impactDateClosure == null
          ))) {
          if (!this.toggle) {
            this.notificationService.showToast("Please complete the declaration before proceeding to Final Submit", "Warning");
            return;
          }
          this.notificationService.showPopup("Are you sure you want to Submit your Response, the report is ready to be sent to DGH, DDGH, DDH, and the PRC Team, hence completing the process of peer review.", 'Confirm').then(data => {
            if (data == 'yes') {
              let response: IResponseInputModel =
              {
                Review_No: this.Data.requestNo,
                Comment_Id: 0,
                Save_Type: "FINAL",
                IsAgreed: 'Y',
                UID: this.memberId,
              }
              this.responseListService.postReviewResponse(response).subscribe(data => {
                if (data.strErrorMsg == null) {
                  let impacts: IImpactInputModel =
                  {
                    strDocNumber: this.Data.requestNo,
                    Save_Type: "FINAL",
                    impactValues: JSON.stringify(this.valueArray),
                    commentRows: JSON.stringify(this.selectionAction),
                    impactDetails: JSON.stringify(this.impactArray),
                    UID: this.memberId,
                  }
                  this.responseListService.postReviewImpacts(impacts).subscribe(data => {
                    if (data.strErrorMsg == null) {
                      this.notificationService.showToast("Peer review Final Response submitted successfully.", "Success");
                      this.exitFunc.emit(true);
                    }
                    else {
                      this.notificationService.showToast(data.strErrorMsg, "Warning");
                    }
                  });
                }
                else {
                  this.notificationService.showToast(data.strErrorMsg, "Warning");
                }
              });
            }
          });
        }
        else {
          this.notificationService.showToast("Impacts and Attachments are mandatory for impact evidence", "Warning");
        }
      //}
      //else
     // {
      //  this.notificationService.showToast("Mandatory to close all the Response before closing the peer review","Warning");
      //}
    }
    else {
      //this.notificationService.showToast("Mandatory to fill Response, Impacts, Evidence Remarks and Attachments for Impacts", "Warning");
      this.notificationService.showToast("Mandatory to fill Response, Impacts, Evidence Remarks", "Warning");
    }

    // if (data == 'yes') 
    //   {
    //     let obj: IImpactInputModel = {
    //       strDocNumber: this.Data.requestNo,
    //       Save_Type: "FINAL",
    //       impactValues: JSON.stringify(this.valueArray),
    //       commentRows: JSON.stringify(this.selectionAction),
    //       impactDetails: JSON.stringify(this.impactArray),
    //       UID: this.memberId,
    //     }
    //     this.responseListService.postReviewImpacts(obj).subscribe(data => {
    //       if (data.strErrorMsg == null) {
    //         this.notificationService.showToast("Peer review Final Impacts submitted successfully.", "Success");
    //         this.exitFunc.emit(true);
    //       }
    //       else{
    //         this.notificationService.showToast(data.strErrorMsg, "Warning");
    //       }
    //     });
    //   }


    // if (!this.toggle) {
    //   this.notificationService.showToast("Please complete the declaration before proceeding to Final Submit", "Warning");
    //   return;
    // }
    // this.notificationService.showPopup("Are you sure you want to Submit your Response and Impacts?", 'Confirm').then(data => {
    //   if (data == 'yes') {
    //     let obj: IResponseInputModel = {
    //       Review_No: this.Data.requestNo,
    //       Comment_Id: 0,
    //       Save_Type: "FINAL",
    //       IsAgreed: 'Y',
    //       UID: this.memberId,
    //     }
    //     this.responseListService.postReviewResponse(obj).subscribe(data => {
    //       if (data.strErrorMsg == null) {
    //         this.notificationService.showToast("Peer review Final Response submitted successfully.", "Success");
    //         this.exitFunc.emit(true);
    //       }
    //       else {
    //         this.notificationService.showToast(data.strErrorMsg, "Warning");
    //       }
    //     });
    //   }
    // });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.responseList.map((doc, indx) => ({
        ...doc,
        Sl_No: indx+1,
        discipline: doc.discipline ? doc.discipline + ` - ${doc.disc_No ? doc.disc_No : ''}` : '',
        potential_Comment: doc.potential_Comment ? doc.potential_Comment + `.${doc.category ? doc.category: ''}` : '',
        responder_Agreed: doc.responder_Agreed ? doc.responder_Agreed == 'Y' ? `COMPLY (Action) - ${doc.action_Remarks ? ' - ' + doc.action_Remarks : ""}` :
          `UNABLE TO COMPLY (Reason) -${doc.reason ? ` - ${doc.reason} ${doc.reason_Remarks ? ' - ' + doc.reason_Remarks : ""}` : " - No Reason"}` : "",
        action_By: doc.action_By ? `${doc.action_By} ${doc.action_Date ? ' - ' + moment(doc.action_Date).format('DD-MMM-yyyy') : ""}` : "",
      }))
    };
    return result;
  }


  public onExcelExport(e: ExcelExportEvent): void {
    e.workbook.sheets[0].columns.forEach((data: { width: number; autoWidth: boolean; textAlign: string; }, i) => {
      if(i==0 || i==1 )
      {
        data.width = 30;
        data.autoWidth = true;
      }
      else
      {
        data.width = 300;
        data.autoWidth =false;
      }
    })

    let values = e.workbook.sheets[0].rows;
    values[0].height = 50;
    values[0].cells[5].wrap = true;
    for (let i = 0; i < e.workbook.sheets[0].columns.length; i++) {
      values[0].cells[i].background = '#507bd1'
      values[0].cells[i].color = "#ffffff"
      values[0].cells[i].textAlign = "center"
      values[0].cells[i].verticalAlign = "center"
      values[0].cells[i].wrap = true;
    }
    for (let i = 1; i < values.length; i++) {
      var len1 = values[i].cells[2].value && values[i].cells[2].value.length ? values[i].cells[2].value.length : 0
      var len2 = values[i].cells[5].value && values[i].cells[5].value.length ? values[i].cells[5].value.length : 0
      var len3 = values[i].cells[7].value && values[i].cells[7].value.length ? values[i].cells[7].value.length : 0
      var maxlength = Math.max(len1, len2, len3)
      if ((len1 > 250) || (len2 > 250) || (len3 > 250)) {
        values[i].height = (maxlength / 3) * 1.75;
        values[i].cells[2].wrap = true;
        values[i].cells[5].wrap = true;
        values[i].cells[7].wrap = true;
      }
      else if((len1 > 100 && len1 < 250) || (len2 > 100 && len2 < 250) || (len3 > 100 && len3 < 250))
      {
        values[i].height = (maxlength / 4) * 1.75;
        values[i].cells[2].wrap = true;
        values[i].cells[5].wrap = true;
        values[i].cells[7].wrap = true;
      }
      else if ((len1 < 100 && len1 > 50) || (len2 < 100 && len2 > 50) || (len3 < 100 && len3 > 50)) {
        values[i].height = (maxlength / 2) * 2.25;
        values[i].cells[2].wrap = true;
        values[i].cells[5].wrap = true;
        values[i].cells[7].wrap = true;
      }
      else {
        values[i].height = maxlength < 30 ? 20 : maxlength;
        values[i].cells[2].wrap = true;
        values[i].cells[5].wrap = true;
        values[i].cells[7].wrap = true;
      }
  
      let category:string = values[i].cells[3].value
      let categoryValue = category.split('.')[1];
      values[i].cells[3].value = category.split('.')[0];
      if (categoryValue == 'High Risk') { values[i].cells[3].background = '#ff0000'; values[i].cells[3].color = "#fff"; values[i].cells[3].bold = true; values[i].cells[3].verticalAlign = "top" }
      if (categoryValue == 'Medium Risk') { values[i].cells[3].background = '#ffbf00'; values[i].cells[3].color = "#fff"; values[i].cells[3].bold = true; values[i].cells[3].verticalAlign = "top" }
      if (categoryValue == 'Low Risk') { values[i].cells[3].background = '#007800'; values[i].cells[3].color = "#fff"; values[i].cells[3].bold = true; values[i].cells[3].verticalAlign = "top" }
    }

    for (var i = 1; i < values.length; i++) {
      for (var j = 0; j < e.workbook.sheets[0].columns.length; j++) {
        if (j == 0 || j == 1 || j==4 || j==6) {
          values[i].cells[j].textAlign = "center";
          values[i].cells[j].verticalAlign = "center"
        }
        else {
          values[i].cells[j].textAlign = "left"
          values[i].cells[j].verticalAlign = "top"
        }
        if (i != 0 && j != 3) {
          values[i].cells[j].background = (i + 1) % 2 ? '#eff3fb' : '#ffffff';
        }
        values[i].cells[j].borderTop = { color: '#000', size: 1 };
        values[i].cells[j].borderBottom = { color: '#000', size: 1 };
        values[i].cells[j].borderLeft = { color: '#000', size: 1 };
        values[i].cells[j].borderRight = { color: '#000', size: 1 };

      }
    }
    for(var i=0;i<1;i++)
    {
      for(var j=0;j<e.workbook.sheets[0].columns.length;j++)
      {
        values[i].cells[j].borderTop = { color: '#000', size: 1 };
        values[i].cells[j].borderBottom = { color: '#000', size: 1 };
        values[i].cells[j].borderLeft = { color: '#000', size: 1 };
        values[i].cells[j].borderRight = { color: '#000', size: 1 };
      }
    }

  }


  public viewImpactAttachmentClick(dataItem: any) {
    const dialog = this.dialog.open(FileListComponent, {
      panelClass: ['mat-dialog-secondary'],
      data: {
        projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRI', libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId, isDeleteEnable: dataItem.ds_Code != 36 ? true : false
      },
    });
    dialog.afterClosed().subscribe((res: any) => {
      this.getResponse();
    });
  }

  uploadAttachmentClick(dataItem: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-primary-for-upload',
      width: '50%',
      data: {
        projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRI', moduleName: 'EDMS', libraryName: FileUploadLibrary.WorkflowDocument,
        createdBy: this.memberId,
        documents: [{ value: dataItem.comment_Id, text: 'EDMS', revisionNo: 'PRI', task_SNo: 0 }],
        isEditable: false,isEnableFullScreen:true
      },
    });
    dialog.afterClosed().subscribe((res: any) => {
      // const dialog2 = this.dialog.open(FileListComponent, {
      // panelClass: ['mat-dialog-secondary'],
      // data: { projectId: this.project_Id, docId: dataItem.comment_Id, revisionNo: 'PRI', libraryName: FileUploadLibrary.WorkflowDocument, 
      //     createdBy: this.memberId, isDeleteEnable: true },
      // });
      // dialog2.afterClosed().subscribe((res: any) => {
      this._fileService.GetFiles({
        libraryNumber: FileUploadLibrary.WorkflowDocument, value: JSON.stringify(
          { projectId: this.commonService.getProjectId(), docId: dataItem.comment_Id, revisionNo: 'PRI' }
        )
      }).subscribe((_data: any[]) => {
        let x: string;
        _data.length > 0 ? x = 'Y' : x = 'N'
        if (dataItem.isAttachment != x) {
          dataItem.isAttachment = x

          let obj: IImpactInputModel = {
            strDocNumber: this.Data.requestNo,
            Save_Type: "PARTIAL",
            impactValues: JSON.stringify(this.valueArray),
            commentRows: JSON.stringify(dataItem),
            impactDetails: JSON.stringify(this.impactArray),
            UID: this.memberId,
          }
          this.responseListService.postReviewImpacts(obj).subscribe();
        }
      });
      // });
    });
  }



  addImpacts() {
    let obj: any = {};
    obj["impactTypes"] = this.impactType;
    // Update Impact value details, when already posted
    if (this.valueArray.length > 0) {
      obj["valueArray"] = this.valueArray;
    }

    let dialogRef = this.dialog.open(AddImpactDialogComponent, {
      panelClass: 'add-impact-mat-dialog-primary',
      data: obj
    })
    dialogRef.afterClosed().subscribe((data) => {
      // Update the selected Impact details
      if (data) {
        this.impactArray = data.impactArray;
        this.valueArray = data.valueArray;
      }
    });
  }

  // onSelectionChange(event: any): void {
  //   if (event['selectedRows'].length > 0) {
  //     if(event['selectedRows'][0]['dataItem'].responder_Agreed == 'Y'){
  //       event['selectedRows'].forEach((element:any) => {
  //         element.dataItem.isSelected = true;
  //         this.selectionAction.push(element.dataItem);
  //       });
  //     }
  //   }
  //   if (event['deselectedRows'].length > 0) {
  //     if(event['deselectedRows'][0]['dataItem'].responder_Agreed == 'Y'){
  //       event['deselectedRows'].forEach((element:any) => {
  //         for (let i = 0; i < this.selectionAction.length; i++) {
  //           if (element.dataItem.comment_Id == this.selectionAction[i].comment_Id) {
  //             element.dataItem.isSelected = false;
  //             this.selectionAction.splice(i, 1);
  //           }
  //         }
  //       });
  //     }
  //   }
  // }

  saveImpact() {
    if (this.selectionAction.length == 0) {
      let isImpactAvailable = true;
      this.selectionAction.forEach(comment => {
        if (!comment.impact) {
          isImpactAvailable = false;
        }
      });

      if (this.valueArray.length > 0 || isImpactAvailable) {
        for (let i = 0; i < this.selectionAction.length; i++) {
          if (this.selectionAction[i].evidence_Remarks == null) { this.selectionAction[i].evidence_Remarks = ''; }
        }

        let payload: IImpactInputModel = {
          strDocNumber: this.Data.requestNo,
          Save_Type: "PARTIAL",
          impactValues: JSON.stringify(this.valueArray),
          commentRows: JSON.stringify(this.selectionAction),
          impactDetails: JSON.stringify(this.impactArray),
          UID: this.memberId
        }
        this.responseListService.postReviewImpacts(payload)
          .subscribe(data => {
            if (data.strErrorMsg == null) {
              this.notificationService.showToast("Peer review impacts updated successfully.", "Success");
              this.getResponse();
            }
            else {
              this.notificationService.showToast(data.strErrorMsg, "Warning");
            }
          });
      }
      else {
        this.notificationService.showToast("Please enter at least one Impact.", "Warning");
      }
    }
    else {
      this.notificationService.showToast("Please select at least one Comment.", "Warning");
    }
  }

}
